var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFull
    ? _c(
        "nav",
        {
          staticClass:
            "container display-flex flex-items-center flex-content-between",
          attrs: { "aria-label": "Awesomeverse Products + Links" },
        },
        [
          _c(
            "div",
            { staticClass: "display-flex flex-items-stretch" },
            [
              _c(
                "site-link",
                {
                  staticClass: "product product-font-awesome product-active",
                  attrs: { to: { name: "home" }, "aria-label": "Font Awesome" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture(
                        "main_navigation_link_click",
                        { destination: "home" }
                      )
                    },
                  },
                },
                [_c("owa-logo-font-awesome")],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "product product-web-awesome",
                  attrs: {
                    id: "product-web-awesome",
                    href: "https://webawesome.com",
                    "aria-label": "Web Awesome",
                    "data-balloon-pos": "down",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$posthog.capture("product_nav_link_click", {
                        destination: "web_awesome",
                      })
                    },
                  },
                },
                [
                  _c("wa-icon", {
                    staticClass: "logo-icon logo-web-awesome",
                    attrs: { name: "web-awesome", family: "brands" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "product product-build-awesome",
                  attrs: {
                    id: "product-build-awesome",
                    href: "https://www.kickstarter.com/projects/fontawesome/build-awesome-pro?ref=90rgxp",
                    "aria-label": "Build Awesome",
                    "data-balloon-pos": "down",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$posthog.capture("product_nav_link_click", {
                        destination: "build_awesome",
                      })
                    },
                  },
                },
                [
                  _c("wa-icon", {
                    staticClass: "logo-icon logo-build-awesome",
                    attrs: { src: "/images/logo-build-awesome-icon.svg" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nav-products-secondary display-flex",
              staticStyle: { gap: "var(--wa-space-2xs)" },
            },
            [
              _c(
                "wa-button",
                {
                  staticClass: "pseudo-product product-podcast-awesome",
                  attrs: {
                    id: "product-podcast-awesome",
                    appearance: "plain",
                    href: "https://www.podcastawesome.com",
                    "aria-label": "Podcast Awesome",
                    "data-balloon-pos": "down",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$posthog.capture("product_nav_link_click", {
                        destination: "podcast_awesome",
                      })
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.solid.faPodcast, size: "lg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "wa-button",
                {
                  staticClass: "pseudo-product product-blog-awesome",
                  attrs: {
                    id: "product-blog-awesome",
                    appearance: "plain",
                    href: "https://blog.fontawesome.com",
                    "aria-label": "Blog Awesome",
                    "data-balloon-pos": "down",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$posthog.capture("product_nav_link_click", {
                        destination: "blog_awesome",
                      })
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.solid.faNewspaper, size: "lg" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _c(
        "div",
        { staticClass: "display-flex nav-products nav-products-drawer" },
        [
          _c(
            "site-link",
            {
              staticClass:
                "display-flex flex-column flex-content-stretch product product-font-awesome product-active",
              attrs: {
                id: "product-drawer-font-awesome",
                to: { name: "home" },
                "aria-label": "Font Awesome",
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture("main_navigation_link_click", {
                    destination: "home",
                    context: "responsive_menu",
                  })
                },
              },
            },
            [
              _c("wa-icon", {
                staticClass: "logo-icon logo-font-awesome",
                attrs: { name: "font-awesome", family: "brands" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "display-flex flex-column flex-content-stretch product product-web-awesome",
              attrs: {
                id: "product-drawer-web-awesome",
                href: "https://webawesome.com",
                "aria-label": "Web Awesome",
                "data-balloon-pos": "down",
              },
              on: {
                click: function ($event) {
                  return _vm.$posthog.capture("product_nav_link_click", {
                    destination: "web_awesome",
                    context: "responsive_menu",
                  })
                },
              },
            },
            [
              _c("wa-icon", {
                staticClass: "logo-icon logo-web-awesome",
                attrs: { name: "web-awesome", family: "brands" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "display-flex flex-column flex-content-stretch product product-build-awesome",
              attrs: {
                id: "product-drawer-build-awesome",
                href: "https://www.kickstarter.com/projects/fontawesome/build-awesome-pro?ref=90rgxp",
                "aria-label": "Build Awesome",
                "data-balloon-pos": "down",
              },
              on: {
                click: function ($event) {
                  return _vm.$posthog.capture("product_nav_link_click", {
                    destination: "build_awesome",
                    context: "responsive_menu",
                  })
                },
              },
            },
            [
              _c("wa-icon", {
                staticClass: "logo-icon logo-build-awesome",
                attrs: { src: "/images/logo-build-awesome-icon.svg" },
              }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }